module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-firefox-permission-2b-3aad51b887967eaa93087ea62ab8a27c.png";